import React from 'react';
import { connect } from 'react-redux';
import { gql, graphql } from 'react-apollo';
import { toast } from 'react-toastify';
import alertFirstGqlMsg from '../../alertFirstGqlMsg';
import { setAccessToken } from '../../StateHOF';

const SendResetPasswordLinkMutation = gql`
  mutation SendResetPasswordLinkMutation($email: String!) {
    sendResetPasswordEmail(email: $email)
  }
`;

const loginImage = require('../../../../assets/husband.jpg');
const logo = require('../../../../assets/Wings-NoTag.svg');
const logowhite = require('../../../../assets/white-logo.png');

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      submitting: false,
    };
  }

  componentWillUnmount() {
    this.setState({ submitting: false });
  }

  render() {
    const onSubmit = async (e) => {
      e.preventDefault();

      this.setState({ submitting: true });

      try {
        await this.props.mutate({
          variables: {
            email: this.state.email,
          },
        });
        toast.success('An email has been sent to your inbox');
        this.props.onSwitch('forgotPassword');
      } catch (err) {
        this.setState({ submitting: false }, () => {
          alertFirstGqlMsg(err);
        });
      }
    };

    const { email, submitting } = this.state;

    return (
      <div className="login-section">
        <div className="login-form-section">
          <div className="login-form-container">
            <div className="curator-login-dark-logo">
              <img src={logo} alt="EncourageX logo" />
            </div>
            <h1 className="heading1-curator">
              EncourageX Curator &amp; Editor Portal
            </h1>
            <div className="curator-form-component w-form">
              <div className="form-label">Recover Password</div>
              <form
                onSubmit={onSubmit}
                id="email-form"
                name="email-form"
                data-name="Email Form"
                className="curator-form-bloc"
              >
                <label htmlFor="email" className="login-field">
                  Email
                </label>
                <input
                  type="email"
                  className="w-input"
                  name="email"
                  data-name="email"
                  id="email"
                  value={email}
                  onChange={e => this.setState({ email: e.target.value })}
                />
                <div>
                  <a
                    href="/"
                    className="pw-link"
                    onClick={(e) => {
                      if (e && e.preventDefault) {
                        e.preventDefault();
                      }
                      if (!submitting) {
                        this.props.onSwitch('forgotPassword');
                      }
                    }}
                  >
                    Back to Login
                  </a>
                </div>
                <button
                  className="login-btn w-button"
                  type="submit"
                  disabled={submitting}
                >
                  {submitting ? 'Processing...' : 'Reset Password'}
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="login-imagery">
          <img alt="family" src={loginImage} className="login-image" />
          <div className="login-image login-gradient" />
          <div>
            <h2 className="h1-login">Build your audience with encouragement</h2>
            <h1 className="heading2-curator">
              EncourageX Curator &amp; Editor Portal
            </h1>
          </div>
          <div className="curator-login-white-logo">
            <img src={logowhite} alt="EncourageX logo" width="152" />
          </div>
        </div>
      </div>
    );
  }
}

const ForgotPasswordFormWithData = graphql(SendResetPasswordLinkMutation)(
  ForgotPassword,
);

const ForgotPasswordFormWithState = connect(
  state => ({ accessToken: state.accessToken }),
  { setAccessToken },
)(ForgotPasswordFormWithData);

export default ForgotPasswordFormWithState;



// WEBPACK FOOTER //
// ./src/byob-cms/src/AppLib/LoginLib/ForgotPassword.js